<template>
  <ModalStructure
    :shouldCloseOnBlur="false"
    :showModal="true"
    @close="handleClose"
  >
    <template v-slot:header>
      <HeadingMedium>
        Change Access Level
      </HeadingMedium>
    </template>
    <template
      v-if="loadingAccessLevels"
      v-slot:body
    >
      <div
        class="loaderContainer"
      >
        <LoadingIcon :scale="3" />
      </div>
    </template>
    <template
      v-else
      v-slot:body
    >
      <RadioGroup
        class="radiogroup"
        name="accesslevel"
        :options="options"
        :value="value"
        @input="handleChange"
      />
    </template>
    <template v-slot:footer>
      <div
        class="modalFooter"
      >
        <ButtonGroupSave
          :isFullWidth="false"
          :primaryButtonProps="primaryButtonProps"
          :secondaryButtonProps="secondaryButtonProps"
          @primaryAction="handleOnSave"
          @secondaryAction="handleClose"
        />
      </div>
    </template>
  </ModalStructure>
</template>
<script>

import {
  ButtonGroupSave,
  HeadingMedium,
  LoadingIcon,
  ModalStructure,
  RadioGroup,
  Types,
} from '@jumpcloud/ui-components';
import { mapActions, mapGetters } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';

const { PrimaryButtonProps, SecondaryButtonProps } = Types;
const PasswordManagerModule = 'PasswordManagerModule';

export default {
  name: 'SharedFolderAccessLevelModal',

  components: {
    ButtonGroupSave,
    HeadingMedium,
    LoadingIcon,
    ModalStructure,
    RadioGroup,
  },

  props: {
    accessLevelId: {
      default: '',
      type: String,
    },
  },

  data() {
    return {
      loadingAccessLevels: false,
      saving: false,
      value: this.accessLevelId,
    };
  },

  computed: {
    ...mapGetters(PasswordManagerModule, [
      'accessLevels',
      'accessLevelsLoaded',
    ]),

    options() {
      return this.accessLevels.map(accessLevel => ({
        key: accessLevel.id,
        isMarkdown: true,
        label: `**${accessLevel.name}**
        *${accessLevel.description}*`,
        value: accessLevel.id,
      }));
    },

    primaryButtonProps() {
      return PrimaryButtonProps({
        isLoading: this.saving,
        isDisabled: this.loadingAccessLevels || this.saving || this.value === this.accessLevelId,
        text: 'save',
      });
    },

    secondaryButtonProps() {
      return SecondaryButtonProps({
        isDisabled: this.saving,
        hasNoBackground: false,
        hasOutline: true,
        text: 'cancel',
        type: 'secondary',
      });
    },
  },

  created() {
    if (!this.accessLevelsLoaded) {
      this.loadAccessLevels();
    }
  },

  methods: {
    ...mapActions(notificationModule, [
      'triggerErrorNotification',
      'triggerSuccessNotification',
    ]),

    ...mapActions(PasswordManagerModule, [
      'fetchAccessLevels',
    ]),

    handleChange(value) {
      this.value = value;
    },

    handleClose() {
      this.$emit('close');
    },

    async handleOnSave() {
      this.$emit('save', this.value);
    },

    async loadAccessLevels() {
      try {
        this.loadingAccessLevels = true;
        await this.fetchAccessLevels();
      } catch (error) {
        this.$emit('close');
        this.triggerErrorNotification({
          title: 'Error',
          message: 'There was a problem loading access level. Please try again.',
        });
      } finally {
        this.loadingAccessLevels = false;
      }
    },
  },
};
</script>

<style scoped>
.modalFooter {
  width: 100%;
}

.radiogroup {
  padding: var(--jc-spacer-x-small) 0;
}

.loaderContainer {
  display: flex;
  justify-content: center;
  overflow: hidden;
}
</style>
